export const NEW_ROLE_ID = 'new';
export const SKIP_ROLE_ID = 'skip';
